import { render, staticRenderFns } from "./EditWebQuestion.vue?vue&type=template&id=39db6748&"
import script from "./EditWebQuestion.vue?vue&type=script&lang=js&"
export * from "./EditWebQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports